module.exports = __webpack_public_path__ + "static/banner.arrow.up.group-c72fb38756393ace01f147f099eb62b8.png";